const tasks = {
  taskPriorities: `/task_fields/GetPriorities/`,
  newTask: `/task/`,
  taskTypes: `/task_fields/GetTypes/`,
  taskRepeatOptions: `/task_fields/GetRepeatOptions/`,
  taskTypesNotifications: `task_fields/GetNotificationTypes/`,
  taskInfoOrEdit: (taskId) => `/task/${taskId}/`,
  allChildTasks: (childId, complement) => `/child/${childId}/getAllTasks/${complement}`,
  updateTimeInTask: (taskId) => `chronometer/${taskId}/`,
  getAllTaskTimers: `chronometer/`,
  updateTaskStatus: (taskId) => `/task/${taskId}/status/`,
};

const myProjects = {
  createProject: `/project/`,
  editProject: (projectId) => `/project/${projectId}/`,
  deleteProject: (projectId) => `/project/${projectId}/`,
  allProjects: (childId) => `/child/${childId}/getProjects/`,
  projectInfo: (projectId) => `/project/${projectId}/`,
};

const calendar = {
  getCalendar: (childId, queryParams) => `/child/${childId}/calendar/${queryParams}`,
};

export { tasks, myProjects, calendar };
